import { useLegacyExperienceNavControlsEnabled } from './useExperienceNavControlsRollout'

/**
 * navHomePath gate for the legacy production experiences (/about, /compareme,
 * /explore, /famousrelatives, /recordme). Unlike the labs experiences, whose
 * routes only exist behind fslabs_discovery_new / discovery_prototypes, these
 * routes are live for everyone - so the new Home pill must stay behind the
 * discovery_prototypes rollout gate instead of shipping to all production
 * users.
 *
 * Signed-out users get no Home in either mode: their WEB entry is the
 * marketing landing page (the app never mounts), and kiosk guests enter via
 * unauth redirects whose Home target would be an auth-gated route.
 *
 * Transitional: dies in the final cleanup plan once the legacy experiences'
 * flag restrictions lift.
 */
export default function useLegacyNavHomePath(homePath) {
  const sharedNavEnabled = useLegacyExperienceNavControlsEnabled()

  return sharedNavEnabled ? homePath : null
}
